export class AppError {
  public get Message(): string {
    switch (this.Code) {
      case 404:
        return 'Page Not Found';
      case 500:
        return 'Internal Server Error';
      default:
        return 'Something went wrong! Please try again';
    }
  }

  public readonly Code: number;
  public readonly ErrorId: string;

  constructor(code: string, id?: string) {
    this.Code = +code;
    this.ErrorId = id || '';
  }
}
